module.exports = __webpack_public_path__ + "static/media/v.900b0df3.png";